import { useEffect, useContext } from 'react';
import { useConfiguration } from '../context/ConfigurationContext';
import RouterContext from '../context/RouterContext';

function useTitle(title: any) {
  const { APP_NAME } = useConfiguration();
  const routerCtx = useContext(RouterContext);
  const navTitle = routerCtx?.navTitle ?? '';
  const setNavTitle = routerCtx?.setNavTitle;

  useEffect(() => {
    if (navTitle) {
      document.title = `${navTitle} | ${APP_NAME}`;
    }
  }, [navTitle, APP_NAME]);

  useEffect(() => {
    if (title && title != navTitle) {
      setNavTitle?.(title ?? null);
    }
  }, [title, navTitle]);
}

export default useTitle;
